/* eslint-disable react/no-array-index-key */
import React from 'react';
import type { Feature as FeatureType } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';
import Feature from '../Feature';

const FeaturesIterator = ({ features }: { features: FeatureType[] }) => (
  <>
    {features.map((feature, index) => (
      <Feature
        key={`${feature.icon}${feature.featureType}${index}`}
        index={index}
        length={features.length}
        icon={feature.icon}
        text={feature.text}
        featureType={feature.featureType}
        iconRight={feature.iconRight}
        tooltip={feature.tooltip}
        tooltipSize={feature.tooltipSize}
        tooltipPosition={feature.tooltipPosition}
        className={feature.className}
        testId={feature.className}
        link={feature.link}
        Modal={feature.Modal}
        callback={feature.callback}
      />
    ))}
  </>
);

export default FeaturesIterator;
